import fire from '../conf/initFirebase';

export const UserActions = Object.freeze({
    FETCH_CONNECTED_USER: 'user/FETCH_CONNECTED_USER',
    FETCH_CONNECTED_USER_SUCCESS: 'user/FETCH_CONNECTED_USER_SUCCESS',
    FETCH_CONNECTED_USER_FAILURE: 'user/FETCH_CONNECTED_USER_FAILURE',

    fetchConnectedUser: () => dispatch => {
        dispatch({type: UserActions.FETCH_CONNECTED_USER});

        fire.auth().onAuthStateChanged((user) => {
            if(user){
                let payload = {
                    displayName: user.displayName,
                    email: user.email,
                    emailVerified: user.emailVerified,
                    photoUrl: user.photoURL,
                    isAdmin: user.email === 'remy.poirier92@gmail.com'
                };
                dispatch({type: UserActions.FETCH_CONNECTED_USER_SUCCESS, payload: payload})
            } else {
                dispatch({type: UserActions.FETCH_CONNECTED_USER_FAILURE})
            }
        })

    }
});


// WEBPACK FOOTER //
// ./src/actions/user.actions.js